module.exports = __webpack_public_path__ + "fonts/ProximaNovaAExCn-Bold.bbbfa19b5e11a27fd71aad23b5a5a227.woff2";